module.exports = __webpack_public_path__ + "static/media/logo-black.b365878b.svg";